import { useRedux } from "hooks-for-redux";

export const [useSelectedModule, setSelectedModule] = useRedux("selectedmodule", "Find");
export const [openDialog, setOpenDialog] = useRedux("opendialog", {open:false, txt:'', neg:null, pos:null});
export const [useChanges, setChanges] = useRedux("changes", false);
export const [useRedirectToDocs, setRedirectToDocs] = useRedux("redirectToDosc", false);
export const [useRedirectToPreview, setRedirectToPreview] = useRedux("redirectToPreview", false);